import React, { useState } from 'react';
import './Chatbot.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import emailjs from '@emailjs/browser'; // Import EmailJS

const Chatbot = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [messages, setMessages] = useState([]);
  const [userData, setUserData] = useState({
    name: "",
    email: "",
    phone: "",
    courseCategory: "",
    selectedCourse: "",
  });
  const [step, setStep] = useState(1);
  const [inputValue, setInputValue] = useState(""); // Store input value
  const [courseOptions, setCourseOptions] = useState([]);
  const [errorMessage, setErrorMessage] = useState(""); // For error handling

  const toggleChat = () => {
    setIsOpen(!isOpen);
  };

  const addMessage = (text, sender = "bot") => {
    setMessages((prevMessages) => [...prevMessages, { sender, text }]);
  };

  const handleInputChange = (input) => {
    addMessage(input, "user");

    if (step === 1) {
      setUserData({ ...userData, name: input });
      setStep(2);
      addMessage("Great! What's your email?");
    } else if (step === 2) {
      if (!validateEmail(input)) {
        setErrorMessage("Please enter a valid email address.");
        addMessage("Oops! That's not a valid email. Please try again.");
        return;
      }
      setUserData({ ...userData, email: input });
      setStep(3);
      addMessage("Thanks! What's your phone number?");
    } else if (step === 3) {
      setUserData({ ...userData, phone: input });
      setStep(4);
      addMessage("Which course category are you interested in?");
    }

    setInputValue(""); // Clear input field after submitting
  };

  const validateEmail = (email) => {
    const re = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
    return re.test(email);
  };

  const handleCourseCategory = (category) => {
    const options =
      category === "Short Term Courses"
        ? ["C", "C++", "Java", "Python", "SQL"]
        : [
            "Full Stack Development",
            "Datacom Networking",
            "Competitive Programming",
            "Python with Data Science",
            "Agile / DevOps",
            "Cloud Computing",
          ];

    setUserData({ ...userData, courseCategory: category });
    setCourseOptions(options);
    setStep(5);
    addMessage(`Please choose a course from the options below:`);
  };

  const handleCourseSelection = (course) => {
    setUserData({ ...userData, selectedCourse: course });
    addMessage(course, "user");
    setStep(6);
    addMessage("Thanks for your choice! Please click submit to complete.");
  };

  const handleSubmit = () => {
    // Send the data to email using EmailJS
    const emailParams = {
      name: userData.name,
      email: userData.email,
      phone: userData.phone,
      courseCategory: userData.courseCategory,
      selectedCourse: userData.selectedCourse,
    };

    emailjs
      .send(
        'service_oit4bk9', // Your service ID
        'template_xny0vd6', // Your template ID
        emailParams,
        '6xlgr_2EFvcPEjnDG' // Your user ID
      )
      .then(
        (response) => {
          console.log("Email sent successfully:", response);
          addMessage("Thank you! Your information has been submitted.");
        },
        (error) => {
          console.log("Error sending email:", error);
          addMessage("Oops! Something went wrong. Please try again.");
        }
      );

    // Reset after submission
    setStep(1);
    setUserData({
      name: "",
      email: "",
      phone: "",
      courseCategory: "",
      selectedCourse: "",
    });
    setCourseOptions([]);
  };

  return (
    <div className="chatbot-container">
      <button className="chatbot-button" onClick={toggleChat}>
        <i className="bi bi-chat-dots-fill "></i>
      </button>

      {isOpen && (
        <div className="chatbot-window">
          <header className="chatbot-header">Chosen IT Academy</header>
          <div className="chatbot-messages">
            {messages.map((msg, index) => (
              <div key={index} className={`chatbot-message ${msg.sender}`}>
                {msg.text}
              </div>
            ))}
            {errorMessage && <div className="error-message">{errorMessage}</div>}
          </div>
          <div className="chatbot-input-container">
            {(step === 1 || step === 2 || step === 3) && (
              <div className="input-with-arrow">
                <input
                  type={step === 1 ? "text" : step === 2 ? "email" : "tel"}
                  value={inputValue}
                  onChange={(e) => setInputValue(e.target.value)}
                  placeholder={
                    step === 1
                      ? "Enter your name"
                      : step === 2
                      ? "Enter your email"
                      : "Enter your phone number"
                  }
                />
                <button
                  className="arrow-button"
                  onClick={() => handleInputChange(inputValue)}
                >
                  <i className="bi bi-arrow-right-circle"></i>
                </button>
              </div>
            )}

            {step === 4 && (
              <div>
                <button onClick={() => handleCourseCategory("Short Term Courses")}>
                  Short Term Courses
                </button>
                <button onClick={() => handleCourseCategory("Job Oriented Courses")}>
                  Job Oriented Courses
                </button>
              </div>
            )}

            {step === 5 && (
              <div>
                {courseOptions.map((course, index) => (
                  <button key={index} onClick={() => handleCourseSelection(course)}>
                    {course}
                  </button>
                ))}
              </div>
            )}

            {step === 6 && (
              <button className="submit-button" onClick={handleSubmit}>
                Submit
              </button>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default Chatbot;
